<script>

import axios from 'axios';

import ElButton from "element-ui/packages/button/src/button.vue";
import ElDialog from "element-ui/packages/dialog/src/component";
import LeadForm from "./LeadForm";

export default {
  components: {
    LeadForm,
    ElButton,
    ElDialog
  },
  props: {
    settings: Object,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    submitLead() {
      this.$refs.leadForm.submitLead(() => {
        this.dialogVisible = false;
      });
    },
  },
  mounted() {
  },
};
</script>
<template>
<div>
  <div v-if="settings.view.type === 'button'">
    <el-button type="primary" @click="dialogVisible = true" :style="settings.style.openButtonStyle">{{settings.lead.openText}}</el-button>
    <el-dialog class="mag-lead-widget-main-dialog"
        :title="settings.lead.title"
        :visible.sync="dialogVisible"
        :modal="true"
        :lock-scroll="false"
        :before-close="handleClose">
      <LeadForm ref="leadForm" :settings="settings" :showSubmitButton="false"></LeadForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{settings.lead.cancelText}}</el-button>
        <el-button type="primary" @click="submitLead()">{{settings.lead.submitText}}</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else>
    <h2 :style="settings.style.headerStyle">{{settings.lead.title}}</h2>
    <LeadForm :settings="settings" :showSubmitButton="true"></LeadForm>
  </div>
</div>
</template>
<style lang="css">

</style>